import React from 'react'
import PropTypes from 'prop-types'

import SEO from 'seo/page'
import { Full as Template } from 'components/Templates'
import {
  Hero,
  HowItWorks,
  Benefits,
  CreateAccount,
  DownloadCitifyd,
  FAQ,
} from 'components/Molecules/HowItWorks'
import { getAppName } from 'models/application'

const Screen = ({ application }) => (
  <Template>
    <SEO title={`How It Works | ${getAppName(application)}`} />
    <Hero />
    <HowItWorks />
    <Benefits />
    <CreateAccount application={application} />
    <DownloadCitifyd />
    <FAQ />
  </Template>
)

Screen.propTypes = {
  application: PropTypes.string,
}

export default Screen
